import { render, staticRenderFns } from "./DialogImage.vue?vue&type=template&id=734ad546"
import script from "./DialogImage.vue?vue&type=script&lang=js"
export * from "./DialogImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports